module.exports = __webpack_public_path__ + "static/img/loadingCode.d82b082.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loadingCode.gif
// module id = Ubz6
// module chunks = 2